import {useNetworkState} from "joynt/network-state";

export default function useNetworkQuality() {
    return useNetworkState();
}